import Label from "lib/Label";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import {
  setIsEnteredAmountZero,
  setIsMaximumAmount,
  setIsRemainingAmountZero,
  setMaxAmountExceeded,
} from "redux/paymentReducer";

const PaymentAmountInput = (props) => {
  const {
    tooltip,
    placeholder,
    label,
    value,
    onChange,
    disabled,
    name,
    class_name,
    size,
    error,
    events,
    isEditable, 
    selectedData = {}, //being used in eval,
    is_disabled,
    validators,
    setSelectedData,
    populate,
    setFormErr,
    formErr,
    payment_id,
  } = props;

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const [maxValueUpdatedForID, setMaxValueUpdatedForID] = useState("");
  const saveData = useSelector((state) => state?.recursive?.saveData);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);
  const copiedData = useSelector((state) => state.formData.copiedData);
  const paymentDetails = useSelector(
    (state) => state?.paymentReducer?.payment_details
  );
  const paymentInfo = useSelector((state) => state.paymentReducer);

  const isMaximumAmount = useSelector(
    (state) => state?.paymentReducer?.isMaximumAmount
  );
  const [maxError, setMaxError] = useState(false);

  const isDisabledPaymentAmount = () => {
    if (!payment_id) return true;

    if (
      selectedData?.payment_ids &&
      Array.isArray(selectedData?.payment_ids) &&
      selectedData?.payment_ids?.length
    ) {
      return selectedData?.payment_ids?.some((item) => {
        return item?.status === "created" || item?.status === "completed";
      });
    }
  };

  useEffect(() => {
    if (!populate) return;

    const { events } = populate;

    if (events && saveData?.length) {
      IndirectEval(events);
      return;
    }

    if (!events) {
      const newValue = IndirectEval(populate);
      onChange({ target: { name, value: newValue } });
    }
  }, [populate, saveData]);

  useEffect(() => {
    if (props?.default_value) {
      dispatch(setSelectedData({ key: name, value: props.default_value }));
    }
  }, [props.default_value]);

  useEffect(() => {
    if (paymentDetails?.payment_mode?.toLowerCase() === "online") {
      dispatch(
        setSelectedData({
          key: "payment_mode",
          value: paymentDetails?.payment_mode?.toLowerCase(),
        })
      );
    }
    if (paymentDetails?.payment_type?.toLowerCase() === "full") {
      dispatch(
        setSelectedData({
          key: "payment_type",
          value: paymentDetails?.payment_type?.toLowerCase(),
        })
      );
    }
  }, [paymentDetails]);
  

  const paymentReducer = useSelector(
    (state) => state.paymentReducer?.payment_details
  );

  const editIndex = useSelector((state) => state.recursive.editIndex);
  const dispatch = useDispatch();

  const onKeyUpCapture = async (item) => {
    if (events) {
      IndirectEval(events?.onKeyUpCapture);
    }
  };
  const getMaxAmount = (paymentReducer) => {
    return (
      paymentReducer?.user_data?.max_amount || paymentReducer?.pending_amount
    );
  };

  const handlePopulateRemainingAmount = () => {
    let remainingAmountToBePaid;
    try {
      remainingAmountToBePaid = getMaxAmount(paymentReducer);
    } catch (error) {
      console.error("Failed to get max amount:", error);
      return;
    }

    const saveDataWithoutTransactionId = saveData.filter(
      (item) => !item.transaction_id
    );

    const totalPaymentAmount = saveDataWithoutTransactionId.reduce(
      (total, item) => {
        const paymentAmount = Number(item?.payment_amount) || 0;
        return total + paymentAmount;
      },
      0
    );

    const totalAmount = parseFloat(
      remainingAmountToBePaid - totalPaymentAmount
    );

    onChange({
      target: {
        name: name,
        value: totalAmount,
      },
    });
  };

  const checkRemainigAmount = (item) => {
    const maxAmount = getMaxAmount(paymentReducer);

    if (value && maxAmount && parseFloat(value) <= parseFloat(maxAmount)) {
      dispatch(setMaxAmountExceeded(false));
      setMaxValueUpdatedForID("");
    } else {
      setMaxValueUpdatedForID(name);
      dispatch(setMaxAmountExceeded(true));
    }
    if (name !== item) {
      setMaxError(parseInt(value) === 0);
      return;
    }
    const total_amount_currently_paying =
      editIndex !== "" && editIndex >= 0 && saveData?.length
        ? calculateTotalPayingWithEditIndex(editIndex, value, saveData)
        : calculateTotalPayingWithoutEditIndex(
            item,
            name,
            recursiveFormData,
            saveData
          );

    setMaxError(total_amount_currently_paying === 0);
    dispatch(setIsEnteredAmountZero(total_amount_currently_paying === 0));

    updateMaxValueAndDispatch(total_amount_currently_paying, paymentDetails);
  };

  const calculateTotalPayingWithEditIndex = (editIndex, value, saveData) => {
    let total_amount_currently_paying = 0;

    saveData?.forEach((item, index) => {
      if (index === editIndex) {
        total_amount_currently_paying += value ? +`${value}` : 0;
      } else if (!item?.transaction_id) {
        total_amount_currently_paying += item?.[name] ? +`${item[name]}` : 0;
      }
    });

    return total_amount_currently_paying;
  };

  const calculateTotalPayingWithoutEditIndex = (
    item,
    name,
    recursiveFormData,
    saveData
  ) => {
    let total_amount_currently_paying = 0;
    if (recursiveFormData) {
      Object.keys(recursiveFormData).forEach((key) => {
        if (key.includes(item)) {
          total_amount_currently_paying += recursiveFormData?.[key]
            ? parseInt(recursiveFormData[key])
            : 0;
        }
      });
    }
    if (saveData?.length) {
      saveData.forEach((item) => {
        if (item?.transaction_id) return;

        total_amount_currently_paying += item?.[name]
          ? parseInt(item[name])
          : 0;
      });
    }
    return total_amount_currently_paying;
  };

  const displayError = () => {
    if (maxError) {
      return "Maximum Booking amount should be greater than 0";
    } else if (isMaximumAmount || maxValueUpdatedForID == name) {
      return error || "Amount cannot be more than remaining amount";
    } else {
      return error;
    }
  };

  const updateMaxValueAndDispatch = (
    total_amount_currently_paying,
    paymentDetails
  ) => {
    const isMaximumAmount =
      paymentDetails?.pending_amount < total_amount_currently_paying;
    const isRemainingAmountZero =
      total_amount_currently_paying === paymentDetails?.pending_amount;
    const maxValueUpdatedForID = isMaximumAmount ? name : "";
    dispatch(setIsRemainingAmountZero(isRemainingAmountZero));
    dispatch(setIsMaximumAmount(isMaximumAmount));
    setMaxValueUpdatedForID(maxValueUpdatedForID);
  };

  const loadingText = useSelector(
    (state) => state.configurationReducer.loadingText
  );

  useEffect(() => {
    displayError();
  }, [maxError, isMaximumAmount, maxValueUpdatedForID]);

  return (
    <div className={size}>
      {label ? (
        <Label label={label} tooltip={tooltip} validators={validators} />
      ) : (
        <div className="mt-2" />
      )}

      <div className="position-relative">
        <input
          name={name}
          className={`form-input ${class_name} ${
            !isEditable && "radioDisabled"
          } ${errorClass}`}
          placeholder={placeholder}
          value={props.default_value ? props.default_value : value || ""}
          disabled={
            is_disabled && eval(is_disabled)
              ? true
              : !isEditable ||
                (isToggled && copiedData?.[name] !== undefined) ||
                (disabled && IndirectEval(disabled))
          }
          onChange={onChange}
          onKeyUpCapture={onKeyUpCapture}
        />
      </div>
      <ErrorMessage error={displayError()} />
    </div>
  );
};
 
PaymentAmountInput.propTypes = {
  tooltip: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  class_name: PropTypes.string,
  size: PropTypes.string,
  error: PropTypes.string,
  events: PropTypes.object,
  isEditable: PropTypes.bool,
  selectedData: PropTypes.object,
  is_disabled: PropTypes.bool,
  validators: PropTypes.array,
  setSelectedData: PropTypes.func,
  populate: PropTypes.string,
  setFormErr: PropTypes.func,
  formErr: PropTypes.object,
  payment_id: PropTypes.string,
  default_value:PropTypes.string
};

export default PaymentAmountInput;
